import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import classNames from 'classnames';
import { ReactElement } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { IClientAllocationGroup } from '~/services/api/clientAllocation/types';
import useRole from '~/store/user/hooks/useRole';
import {
  DUPLICATE_CLIENT_ALLOCATION,
  EDIT_CLIENT_ALLOCATION,
  VIEW_CLIENT_ALLOCATION,
} from '~/ui/constants/paths';
import EmptyState from '~/ui/pages/Notifications/components/EmptyState';
import { isoToLocal } from '~/utils/date/date';

import { ReactComponent as EditIcon } from '~/ui/assets/images/edit.svg';

import styles from './ClientAllocation.module.scss';

interface IProps {
  actTeamId: string;
  noActions: boolean;
  clientsAllocationList: IClientAllocationGroup[];
}

const ClientAllocationTable = ({
  actTeamId,
  noActions,
  clientsAllocationList,
}: IProps): ReactElement => {
  const navigate = useNavigate();
  const { isActTeamMember, isGlobalUser } = useRole();

  const navigateToEdit = (item: IClientAllocationGroup) => {
    let editPath = EDIT_CLIENT_ALLOCATION.replace(
      ':clientAllocationDate',
      String(item.date.split('T')[0]),
    );

    if (!isGlobalUser) {
      editPath = editPath.replace(':actTeamId', actTeamId);
    }

    navigate(editPath);
  };

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Date</TableCell>
          {!noActions && <TableCell align="right">Actions</TableCell>}
          <TableCell />
        </TableRow>
      </TableHead>

      <TableBody>
        {clientsAllocationList?.length ? (
          clientsAllocationList.map(item => {
            const disabled = (isActTeamMember || isGlobalUser) && !item.containsOwn;

            return (
              <TableRow key={item.date}>
                <TableCell>
                  <Link
                    to={VIEW_CLIENT_ALLOCATION.replace(':actTeamId', actTeamId || 'null').replace(
                      ':clientAllocationDate',
                      String(item.date.split('T')[0]),
                    )}
                    className={styles.linkView}
                  >
                    {isoToLocal(item.date)}
                  </Link>
                </TableCell>
                {!noActions && (
                  <>
                    <TableCell align="right">
                      <IconButton
                        disabled={disabled}
                        onClick={() => {
                          navigateToEdit(item);
                        }}
                      >
                        <EditIcon className={disabled ? styles.disabled : ''} />
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      <span
                        role="presentation"
                        onClick={() =>
                          !disabled && actTeamId
                            ? navigate(
                                DUPLICATE_CLIENT_ALLOCATION.replace(
                                  ':actTeamId',
                                  actTeamId,
                                ).replace(':clientAllocationDate', String(item.date.split('T')[0])),
                              )
                            : undefined
                        }
                        className={classNames(styles.duplicateButton, {
                          [styles.disabled]: disabled,
                        })}
                      >
                        Duplicate
                      </span>
                    </TableCell>
                  </>
                )}
              </TableRow>
            );
          })
        ) : (
          <EmptyState />
        )}
      </TableBody>
    </Table>
  );
};

export default ClientAllocationTable;
